import BaseInput from './Base';
import OutlinedInput from '../Input';

const OutlinedTextarea = (props) => (
  <BaseInput {...props} component={OutlinedInput} />
);

export default OutlinedTextarea;
